// Core packages
import { formatDate } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

// Third party packages
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';
import * as FileSaver from "file-saver";
import { default as moment } from 'moment';
import { ToastrService } from "ngx-toastr";
import { combineLatest, merge, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize, startWith, take, tap } from 'rxjs/operators';

// Core packages
import { MatDialog, MatOptionSelectionChange } from '@angular/material';
import { AuthService } from 'src/app/modules/auth/auth.service';
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { DeadlinesService } from 'src/app/modules/deadlines/deadlines.service';
import { CancelContractDialogComponent } from "src/app/modules/properties/components/cancel-contract-dialog/cancel-contract-dialog.component";
import { PropertyExpireContractItemDialogComponent } from "src/app/modules/properties/components/contract-expire-item-dialog/contract-expire-item-dialog.component";
import { DocumentDownloadDialogComponent } from 'src/app/modules/properties/components/document-download-dialog/document-download-dialog.component';
import { PropertyDetailDocumentItemDialogComponent } from 'src/app/modules/properties/components/document-item-dialog/document-item-dialog.component';
import { PropertyDetailDocumentItemPrintDialogComponent } from "src/app/modules/properties/components/document-item-print-dialog/document-item-print-dialog.component";
import { PropertyDetailDocumentPrintModuleDialogComponent } from "src/app/modules/properties/components/document-print-module-dialog/document-print-module-dialog.component";
import { CondoStructuresService } from "src/app/modules/properties/condo-structures.service";
import { DocumentArchivesService } from "src/app/modules/properties/document-archives.service";
import DocumentTypeStructure from 'src/app/modules/properties/documentTypes';
import { PropertiesService } from 'src/app/modules/properties/properties.service';
import { SettingsService } from "src/app/modules/settings/settings.service";
import { SuppliersService } from 'src/app/modules/suppliers/suppliers.service';
import { ListSetting } from 'src/app/shared/interfaces/list-setting.interface';
import { Company } from "src/app/shared/models/company/company.model";
import { PropertyInterface } from 'src/app/shared/models/property/property.interface';
import { IUser } from 'src/app/shared/models/user/user.interface';
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from 'src/app/shared/services/helper.service';
import { ListsService } from 'src/app/shared/services/lists.service';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { DeadlinesDataSource } from 'src/app/shared/utils/data-sources/deadlines-data-source';
import { PropertyDeleteDocumentItemDialogComponent } from "../../../properties/components/document-delete-item-dialog/document-delete-item-dialog.component";
import { BalanceListDialogComponent } from '../../components/balances-list-dialog/balances-list-dialog.component';
@Component({
  selector: 'app-documents-deadlines-list',
  templateUrl: './documents-deadlines-list.page.html',
  styleUrls: ['./documents-deadlines-list.page.scss']
})
export class DocumentsDeadlinesListComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  loggedUser: IUser;
  loggedUserPermissions: string[];
  loggedUserRole: any;
  currentRole: any;

  // BEGIN - Table deadlines
  displayedColumns: string[] = ['index', 'property', 'masterCode', 'structureObjectName', 'document', 'providerName', 'memoTime', 'renewalType', 'endDate', 'actions'];
  dataSource: DeadlinesDataSource;
  @ViewChild('sort1', { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  // @ViewChild('input', { static: true }) input: ElementRef;
  propertyFilter: FormControl = new FormControl('');
  masterCodeFilter: FormControl = new FormControl('');
  // areaFilter: FormControl = new FormControl('');
  structureObjectNameFilter: FormControl = new FormControl('');
  providerNameFilter: FormControl = new FormControl('');
  documentFilter: FormControl = new FormControl('');
  endDateFilter: FormControl = new FormControl(moment().startOf('day'));
  memoTimeFilter: FormControl = new FormControl('');
  renewalTypeFilter: FormControl = new FormControl('');
  // END - Table deadlines

  activeRoute: string;
  propertyIsLoading = false;
  availableProperties: PropertyInterface[] = [];
  availableTypes = [];
  public documentTypeStructure: DocumentTypeStructure = new DocumentTypeStructure();

  // Dati aggiuntivi elenco/nuovo elemento
  suppliersName: any[] = [];
  yearsOfStorage: any[] = [];
  conductorName: any[] = [];
  nameInterventionArchiving: any[] = [];

  documentTemplateId = "";
  documentTemplate: any[] = [];

  loggedUserMaster = false;
  companyData = {};
  company: Company = new Company();

  /**
   * Class constructor
   */
  constructor(
    public dialog: MatDialog,
    public cancelContractDialog: MatDialog,
    private deadlinesService: DeadlinesService,
    private helperService: HelperService,
    private authService: AuthService,
    private translateService: TranslateService,
    private themeService: ThemeService,
    private listsService: ListsService,
    private propertiesService: PropertiesService,
    private configService: ConfigService,
    private suppliersService: SuppliersService,
    private settingsService: SettingsService,
    private companiesService: CompaniesService,
    private condoStructuresService: CondoStructuresService,
    private toastrService: ToastrService,
    private documentArchivesService: DocumentArchivesService,
  ) { }

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    // Set page title
    this.themeService.setPageTitle(this.translateService.instant('deadlines.documentsList.pageTitle'));

    // Get logged user data
    this.subscriptions.push(this.authService.loggedUser$.subscribe(res => this.loggedUser = res));
    this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(res => this.loggedUserPermissions = res));

    // Get logged user's role data
    this.currentRole = this.loggedUser.userRoles.find((obj: any) => {
      return (
        obj._id.toString() ===
        this.authService.loggedUserRequestedRole$.getValue().toString()
      );
    });
    this.loggedUserRole = this.currentRole.role;
    if (
      this.currentRole.role.type === "master" ||
      this.currentRole.role.type === "collaborator"
    ) {
      this.loggedUserMaster = true;
      if (this.currentRole.company._id !== "") {
        this.subscriptions.push(
          this.companiesService
            .get(this.currentRole.company._id)
            .subscribe((res) => {
              if (res.status) {
                this.companyData = res.data;
                this.company.setData(res.data);
              }
            })
        );
      }
    }

    // Init data source
    this.dataSource = new DeadlinesDataSource(this.deadlinesService, this.helperService, this.translateService);

    // Init areas
    this.availableTypes = this.configService.availableDocumentAreas
      .map((element: any) => {
        return {
          value: element,
          label: this.translateService.instant(`properties.documents.areas.${element}`),
        }
      });

    this.subscriptions.push(
      this.settingsService.getDocument().subscribe(
        (res) => {
          if (res.status) {
            if (
              res.data &&
              Array.isArray(res.data) &&
              res.data.length > 0 &&
              res.data[0].area &&
              Array.isArray(res.data[0].area)
            ) {
              this.documentTemplateId = res.data[0]._id;
              this.documentTemplate = res.data[0].area;
            }
          }
        },
        (err) => {
          //
        }
      )
    );

    // Subscribe to listsService and update this list settings
    this.subscribeToListsSettings('deadlines');
  }

  /**
   * After view init logic
   *
   * @since 1.0.0
   */
  ngAfterViewInit(): void {
    // Load first set of data
    this.loadPage();

    // Reset pagination after sorting
    this.subscriptions.push(this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0));

    // Once user change sorting OR change page
    // let's reload the page data
    this.subscriptions.push(
      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          tap(() => this.loadPage())
        )
        .subscribe()
    );

    // Handle server-side filtering through general search
    // this.subscriptions.push(
    //   fromEvent(this.input.nativeElement, 'keyup')
    //     .pipe(
    //       debounceTime(this.configService.debounceTime), // max 1 query every 350 milliseconts
    //       distinctUntilChanged(), // Eliminate duplicate values
    //       tap(() => {
    //         this.paginator.pageIndex = 0; // Reset page
    //         this.loadPage();
    //       })
    //     )
    //     .subscribe()
    // );

    // Handle server-side filtering through column-specific search
    // Why do we use "null as string"? --> @see https://github.com/ReactiveX/rxjs/issues/4772
    this.subscriptions.push(
      combineLatest([
        this.propertyFilter.valueChanges.pipe(startWith(null as string)),
        this.masterCodeFilter.valueChanges.pipe(startWith(null as string)),
        this.documentFilter.valueChanges.pipe(startWith(null as string)),
        this.endDateFilter.valueChanges.pipe(startWith(null as string)),
        this.memoTimeFilter.valueChanges.pipe(startWith(null as string)),
        this.renewalTypeFilter.valueChanges.pipe(startWith(null as string)),
        this.structureObjectNameFilter.valueChanges.pipe(startWith(null as string)),
        this.providerNameFilter.valueChanges.pipe(startWith(null as string)),
        // this.areaFilter.valueChanges.pipe(startWith(null as string)),
        // this.createdAtFilter.valueChanges.pipe(startWith(null as string)),
      ])
        .pipe(
          debounceTime(this.configService.debounceTime), // max 1 query every 350 milliseconts
          distinctUntilChanged(), // Eliminate duplicate values
        )
        .subscribe(res => {
          // Handle property filter
          if (res) {
            this.propertyIsLoading = true;
            this.getAvailableProperties({
              general: this.propertyFilter.value
            });
          }

          // Load page only if at least one value is not null
          if (!res.every(value => value === null)) {
            this.paginator.pageIndex = 0;
            this.loadPage();
          }
        }
        )
    );
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all deadlines
    this.subscriptions.forEach(sub => sub.unsubscribe());

    // Push current list settings to the listsService
    this.listsService.setListSetting(
      'deadlines',
      this.paginator.pageIndex.valueOf(),
      this.paginator.pageSize.valueOf(),
      {
        general: '', // this.input.nativeElement.value,
        property: this.propertyFilter.value,
        masterCode: this.masterCodeFilter.value,
        // area: this.areaFilter.value,
        structureObjectName: this.structureObjectNameFilter.value,
        providerName: this.providerNameFilter.value,
        document: this.documentFilter.value,
        endDate: this.endDateFilter.value,
        memoTime: this.memoTimeFilter.value,
        renewalType: this.renewalTypeFilter.value,
      }
    );
  }

  /**
   * Load requested data page
   *
   * @since 1.0.0
   */
  loadPage(): void {
    const start = this.paginator.pageIndex * this.paginator.pageSize;
    const length = this.paginator.pageSize;
    const search = {
      general: '', // this.input.nativeElement.value,
      property: this.propertyFilter.value ? this.propertyFilter.value._id : undefined,
      masterCode: this.masterCodeFilter.value,
      // area: this.areaFilter.value,
      structureObjectName: this.structureObjectNameFilter.value,
      providerName: this.providerNameFilter.value,
      document: this.documentFilter.value,
      endDate: this.endDateFilter.value ? new Date(this.endDateFilter.value).toISOString() : undefined,
      memoTime: this.memoTimeFilter.value,
      renewalType: this.renewalTypeFilter.value,
    };
    this.dataSource.loadDocumentsItems(start, length, this.sort.active, this.sort.direction, search);
  }

  /**
   * Export deadlines in a file with given format
   *
   * @since 1.0.0
   */
  onExport(): void {
    const date = formatDate(new Date(), 'yyyyMMddhhmmss', 'en-EN');
    const fileName = `${this.translateService.instant('deadlines.documentsList.exportFileName')} ${date}`;
    this.subscriptions.push(
      this.deadlinesService.getDocumentsExport().subscribe(
        res => {
          const fileBlob = res;
          const blob = new Blob([fileBlob], {
            type: 'application/vnd.ms-excel'
          });
          FileSaver.saveAs(blob, `${fileName}.xlsx`);
        },
        err => {
          this.helperService.handleError(err);
        }
      )
    );
  }

  /**
   * Reset table's filters
   *
   * @since 1.0.0
   */
  onResetFilters(): void {
    // Reset lists service data
    this.listsService.setListSetting('deadlines', 0, 10, {});

    // Reset tables' filters
    // this.input.nativeElement.value = '';
    this.propertyFilter.setValue(null);
    this.masterCodeFilter.setValue(null);
    // this.areaFilter.setValue(null);
    this.structureObjectNameFilter.setValue(null);
    this.providerNameFilter.setValue(null);
    this.documentFilter.setValue(null);
    this.endDateFilter.setValue(moment().startOf('day'));
    this.memoTimeFilter.setValue(null);
    this.renewalTypeFilter.setValue(null);

    // Reset tables' sorting versus and column
    this.sort.direction = "asc";
    this.sort.active = "endDate";
    this.sort._stateChanges.next();

    // Reset paginator
    this.paginator.pageIndex = 0;
    this.paginator.pageSize = 10;

    // Reload table's data
    this.loadPage();
  }

  /**
   * Reset given filter value and reload the page
   *
   * @since 1.0.0
   */
  onResetFilter(filter: FormControl): void {
    filter.reset();
    this.loadPage();
  }

  /**
   * Subscribe to lists settings service to allow this list
   * to remember current filters once users navigate to another page.
   * In this way once user will come back to this page he will
   * have all previous settings (such as page number, page size, search, ...)
   *
   * @since 1.0.0
   */
  subscribeToListsSettings(name: string): void {
    this.listsService.enable();
    this.subscriptions.push(
      this.listsService.listsSettings$.subscribe(
        (settings: ListSetting[]) => {
          if (settings.length) {
            settings.forEach((setting: ListSetting) => {
              if (setting.name === name) {
                if (setting.pageIndex) {
                  this.paginator.pageIndex = setting.pageIndex;
                }
                if (setting.pageSize) {
                  this.paginator.pageSize = setting.pageSize;
                }
                if (setting.search && setting.search.general) {
                  // this.input.nativeElement.value = setting.search.general;
                }
                if (setting.search && setting.search.property) {
                  this.propertyFilter.setValue(setting.search.property);
                }
                if (setting.search && setting.search.masterCode) {
                  this.masterCodeFilter.setValue(setting.search.masterCode);
                }
                // if (setting.search && setting.search.area) {
                //   this.areaFilter.setValue(setting.search.area);
                // }
                if (setting.search && setting.search.structureObjectName) {
                  this.structureObjectNameFilter.setValue(setting.search.structureObjectName);
                }
                if (setting.search && setting.search.providerName) {
                  this.providerNameFilter.setValue(setting.search.providerName);
                }
                if (setting.search && setting.search.document) {
                  this.documentFilter.setValue(setting.search.document);
                }
                if (setting.search && setting.search.date) {
                  this.endDateFilter.setValue(setting.search.date);
                }
                if (setting.search && setting.search.memoTime) {
                  this.memoTimeFilter.setValue(setting.search.memoTime);
                }
                if (setting.search && setting.search.renewalType) {
                  this.renewalTypeFilter.setValue(setting.search.renewalType);
                }
              }
            });
          }
        }
      )
    );
  }

  /**
   * Reset general search input and dispath a 'keyup' event
   * so that the table re-render his rows
   *
   * @since 1.0.0
   */
  resetInput(): void {
    // this.input.nativeElement.value = '';
    const event = new KeyboardEvent('keyup');
    // this.input.nativeElement.dispatchEvent(event);
  }


  /**
   * Get the list of available admins and owners
   * used to allow filtering on owner and admin columns
   *
   * @since 1.0.0
   */
  getAvailableProperties(search?: any): void {
    this.subscriptions.push(
      this.propertiesService
        .getList(0, null, null, null, search)
        .pipe(
          finalize(() => {
            this.propertyIsLoading = false;
          })
        )
        .subscribe(res => {
          if (res.status) {
            this.availableProperties = res.data.items;
          }
        })
    );
  }

  /**
   * Used to handle the display of selected result
   *
   * @since 1.0.0
   *
   * @param arg Data to be displayed
   * @returns result string to display or undefined
   */
  displayFn(arg?: PropertyInterface): string | undefined {
    return arg ? `${arg.name}` : undefined;
  }

  /**
   * Handle click on a selected property in the mat-autocomplete list and fires the loadPage()
   *
   * @since 1.0.0
   */
  onPropertyFilterSelected(event: MatOptionSelectionChange): void {
    const value = event.source.value;
    this.propertyFilter.setValue(value, { emitEvent: false });
    this.loadPage();
  }


  /**
   * Handle click on "Open" button next to each item
   * and open a view dialog for clicked element
   *
   * @since 1.0.0
   */
  onOpenDialog(element: any): void {
    if (!element) {
      return;
    }

    // Open dialog
    const dialogRef = this.dialog.open(BalanceListDialogComponent, {
      minWidth: '60%',
      maxHeight: '98vh',
      data: {
        element,
        propertyId: element._id,
      }
    });

    // On dialog closing, check if something is changed
    // If so, let's reload table data
    this.subscriptions.push(dialogRef.afterClosed()
      .subscribe(
        res => {
          if (res) {
            this.loadPage();
            return;
          }
        },
        err => {
          this.helperService.handleError(err);
        }
      ));
  }

  

  /**
   * Handle click on document and open dialog box to edit/show document data
   * 
   * modalTitle: title of dialogbox from document name
   * documentKey: doc type, es. AA1, AA2, etc.
   * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
   * subDocumentId: the ID of sub document into array of docs type (es. AA1)
   * itemData: data value of form items
   * action: edit or show doc data
   * documentFather: 
   * area: 
   * structureId: related structure Id
   * expired: 
   * contractPdfMsg: 
   *
   * @since 1.0.0
   */
  onToggleEditShowDocument(
    modalTitle: string,
    documentKey: string,
    documentId: string,
    subDocumentId: string,
    itemData: any,
    action: string,
    documentArchiveId: string,
    propertyData: any,
    documentFather?: string,
    keyTranslateTitle?: string,
    area?: string,
    structureId?: string,
    expired?: boolean,
    contractPdfMsg?: any,
    cancellationRequestDate?: string,
    cancellationRequestBy?: string,
  ): void {

    if (structureId === '') {
      structureId = undefined;
    }
    // Create formly default fields
    const defaultFields = [
      {
        className: "col-12 col-md-12 col-xl-12",
        type: "textarea",
        key: "contenutoDocumento",
        templateOptions: {
          label: this.translateService.instant(
            "properties.detail.documentArchive.fields.contenutoDocumento"
          ),
          placeholder: this.translateService.instant(
            "properties.detail.documentArchive.fields.contenutoDocumento"
          ),
          required: true,
          minLength: 2,
          maxLength: 500,
          rows: 5,
          disabled: action === "show" ? true : false,
        },
      },
      {
        className: "col-12 col-md-12 col-xl-12",
        type: "input",
        key: "protocollo",
        templateOptions: {
          readonly:false,
          label: this.translateService.instant(
            "properties.detail.documentArchive.fields.protocollo"
          ),
          placeholder: this.translateService.instant(
            "properties.detail.documentArchive.fields.protocollo"
          ),
          required: false,
          minLength: 0,
          maxLength: 500,
          disabled: action === "show" ? true : false,
        },
      },
      {
        className: "col-12 col-md-12 col-xl-12",
        type: "textarea",
        key: "keyword",
        templateOptions: {
          readonly:false,
          label: this.translateService.instant(
            "properties.detail.documentArchive.fields.keyword"
          ),
          placeholder: this.translateService.instant(
            "properties.detail.documentArchive.fields.keyword"
          ),
          required: false,
          minLength: 0,
          maxLength: 1000,
          rows: 3,
          disabled: action === "show" ? true : false,
        },
      }
    ];

    // create fields formly from document key: es AA1
    // const aryfields = this.documentTypeStructure.getFormlyFields(
    //   documentKey,
    //   false
    // );
    const schemaType = JSON.parse(
      JSON.stringify(this.documentTypeStructure.getDocumentType2(documentKey, this.documentTemplate))
    );
    const aryfields = this.documentTypeStructure.getFormlyFields2(
      schemaType,
      false
    );
    aryfields.forEach((item: any) => {
      if (item.templateOptions && item.templateOptions.placeholder) {
        item.templateOptions.placeholder = this.translateService.instant(
          item.templateOptions.placeholder
        );
      }
      if (item.type === "select") {
        if (Array.isArray(item.templateOptions.options)) {
          item.templateOptions.options.forEach((subItem: any) => {
            subItem.label = this.translateService.instant(subItem.label);
          });
        }
      }
      if (item.type === "selectNew") {
        item.type = "autocomplete";
        if (item.templateOptions.initialValues) {
          const options: any[] = [];
          switch (item.templateOptions.initialValues) {
            case "suppliersName":
              this.suppliersName.forEach((subItem: any) => {
                // options.push({
                //   value: subItem,
                //   label: subItem,
                // });
                options.push(subItem);
              });
              break;
            case "yearsOfStorage":
              this.yearsOfStorage.forEach((subItem: any) => {
                // options.push({
                //   value: subItem,
                //   label: subItem,
                // });
                options.push(subItem);
              });
              break;
            case "conductorName":
              this.conductorName.forEach((subItem: any) => {
                // options.push({
                //   value: subItem,
                //   label: subItem,
                // });
                options.push(subItem);
              });
              break;
            case "nameInterventionArchiving":
              this.nameInterventionArchiving.forEach((subItem: any) => {
                // options.push({
                //   value: subItem,
                //   label: subItem,
                // });
                options.push(subItem);
              });
              break;
          }
          item.templateOptions.initialValues = options;
          item.templateOptions.addTagText = this.translateService.instant(
            item.templateOptions.addTagText
          );
          item.templateOptions.customLabel = this.translateService.instant(
            item.templateOptions.customLabel
          );
        }
      }
      if (
        item.type === "autocomplete" ||
        item.type === "autocomplete-supplier"
      ) {
        item.templateOptions.addTagText = this.translateService.instant(
          item.templateOptions.addTagText
        );
        item.templateOptions.customLabel = this.translateService.instant(
          item.templateOptions.customLabel
        );
        if (item.templateOptions.search$ === "suppliersService") {
          item.templateOptions.search$ =
            this.suppliersService.getListV2.bind(this);
        }
      } else {
        if (item.templateOptions && item.templateOptions.label) {
          item.templateOptions.label = this.translateService.instant(
            item.templateOptions.label
          );
        }
      }

      if (action === "show" && item.templateOptions) {
        item.templateOptions.disabled = true;
      }
    });

    // const contract = this.documentTypeStructure.isContract(documentKey);
    const contract = this.documentTypeStructure.isContract2(documentKey, this.documentTemplate);

    const fieldGroup = aryfields.concat(defaultFields);

    const itemConfig = [
      {
        fieldGroupClassName: "row",
        fieldGroup: fieldGroup,
      },
    ];

    const propertyCode = propertyData.code;
    const companyCode = this.company.get("code");

    let barCode = "";
    if (itemData && itemData.barCode) {
      barCode = itemData.barCode;
    }

    let selectedArea = 0;
    if (area) {
      switch (area) {
        case "amministrativo": selectedArea = 1; break;
        case "contratti": selectedArea = 2; break;
        case "tecnico": selectedArea = 3; break;
        case "unitaImmobiliari": selectedArea = 4; break;
      }
    }

    let title;
    if (keyTranslateTitle) {
      title = keyTranslateTitle.split("properties.documents.")[1];
    }
    
    if (itemData && cancellationRequestBy) {
      itemData.cancellationRequestDate = cancellationRequestDate;
      itemData.cancellationRequestBy = cancellationRequestBy;
    }

    // this.structureSelected = this.structureSelected.find(el => el.id === structureId);
    const dialogRef = this.dialog.open(PropertyDetailDocumentItemDialogComponent, {
      data: {
        modalTitle,
        documentArchiveId,
        documentTypeRoute:
          this.documentTypeStructure.getDocRoute2(documentKey, this.documentTemplate),
        documentId,
        documentKey,
        subDocumentId,
        itemData,
        itemConfig,
        propertyCode,
        companyCode,
        barCode,
        action,
        documentFather,
        keyTranslateTitle: title,
        structureId,
        contract,
        expired,
        contractPdfMsg,
        selectedArea,
        property: propertyData,
        companyData: this.loggedUserMaster ? this.companyData : "",
        propertyName: propertyData.name,
      },
      width: "700px",
    });

    dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(
        (res) => {
          if (!res) {
            // return;
          } else {
            // recreate view of all docs to show new inserted doc
            this.loadPage();
          }
        },
        (err) => {
          this.helperService.handleError(err);
        }
      );
  }

  /**
   * Handle click on document form to download file
   * itemData: data value of form items
   *
   * @since 1.0.0
   */
  onToggleDownloadDocument(
    propertyId: string,
    documents: any[],
  ): void {
    if (!documents || !documents.length) {
      return;
    }
    const dialogRef = this.dialog.open(DocumentDownloadDialogComponent, {
      data: {
        propertyId: propertyId,
        documents,
      },
      width: "600px"
    });
    dialogRef.beforeClosed()
      .pipe(
        take(1)
      )
      .subscribe(
        res => {
          if (!res) {
            return;
          } else {
            // Reload page after dialog closed
            this.loadPage();
          }
        }
      );
  }


  /**
   * Handle click on document form to delete document
   * documentArchiveId: Id of the document archive
   * itemData: data value of the document
   *
   * @since 1.0.0
   */
  onToggleDeleteDocument(
    documentArchiveId: string,
    itemData: any,
  ): void {
    const dialogRef = this.dialog.open(
      PropertyDeleteDocumentItemDialogComponent,
      {
        data: {
          documentArchiveId,
          barCode: itemData.barCode ? itemData.barCode : '',
        },
        width: "600px",
      }
    );
    dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(
        (res) => {
          if (!res) {
            return;
          } else {
            this.loadPage();
          }
        },
        (err) => {
          this.helperService.handleError(err);
        }
      );
  }

  /**
   * Handle click on document form to print file
   * area: document area
   * topic: document topic
   * type: document type
   * modalTitle: title of dialogbox from document name
   * documentKey: doc type, es. AA1, AA2, etc.
   * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
   * subDocumentId: the ID of sub document into array of docs type (es. AA1)
   * itemData: data value of form items
   *
   * @since 1.0.0
   */
  onTogglePrintDocument(
    subArea: string,
    area: string,
    topic: string,
    structure: string,
    modalTitle: string,
    documentKey: string,
    documentId: string,
    subDocumentId: string,
    itemData: any,
    propertyData: any,
    documentArchiveId: string,
  ): void {
    const propertyCode = propertyData.code;

    let areaNumber = "0";
    if (subArea) {
      switch (subArea) {
        case "amministrativo": areaNumber = "1"; break;
        case "contratti": areaNumber = "2"; break;
        case "tecnico": areaNumber = "3"; break;
        case "unitaImmobiliari": areaNumber = "4"; break;
      }
    }
    const selectedArea = this.documentTypeStructure.getDocumentArea2(
      areaNumber,
      this.documentTemplate
    );

    let barCode = "";
    if (itemData && itemData.barCode) {
      barCode = itemData.barCode;
    }
    const name = propertyData.name;
    const city = propertyData.address.city;
    const address = `${propertyData.address.route} ${propertyData.address.streetNumber}`;

    this.dialog.open(PropertyDetailDocumentItemPrintDialogComponent, {
      data: {
        modalTitle,
        documentArchiveId,
        documentTypeRoute: this.documentTypeStructure.getDocRoute2(documentKey, this.documentTemplate),
        documentId,
        documentKey,
        subDocumentId,
        itemData,
        propertyCode,
        barCode,
        name,
        city,
        address,
        area,
        topic: this.translateService.instant(`properties.documents.${topic}`),
        structure,
        subArea: selectedArea && selectedArea.title ? selectedArea.title : "",
      },
      width: "700px",
    });

  }

  /**
   * Handle click on document form to print nodule
   * area: document area
   * topic: document topic
   * type: document type
   * modalTitle: title of dialogbox from document name
   * documentKey: doc type, es. AA1, AA2, etc.
   * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
   * subDocumentId: the ID of sub document into array of docs type (es. AA1)
   * itemData: data value of form items
   *
   * @since 1.0.0
   */
  onTogglePrintModuleDoc(
    subArea: string,
    subTopic: string,
    structure: string,
    modalTitle: string,
    itemData: any,
    property: any,
  ): void {
    let areaNumber = "0";
    if (subArea) {
      switch (subArea) {
        case "amministrativo": areaNumber = "1"; break;
        case "contratti": areaNumber = "2"; break;
        case "tecnico": areaNumber = "3"; break;
        case "unitaImmobiliari": areaNumber = "4"; break;
      }
    }
    const selectedArea = this.documentTypeStructure.getDocumentArea2(
      areaNumber,
      this.documentTemplate
    );

    this.dialog.open(PropertyDetailDocumentPrintModuleDialogComponent, {
      data: {
        modalTitle,
        itemData,
        property: property,
        area: selectedArea && selectedArea.title ? selectedArea.title : "",
        docs: [{ title: modalTitle, subDoc: subTopic }],
        structure: structure ? [{ name: structure }] : [],
      },
      width: "700px",
    });

  }

  /**
   * Handle click on document form to delete file
   * modalTitle: title of dialogbox from document name
   * documentKey: doc type, es. AA1, AA2, etc.
   * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
   * subDocumentId: the ID of sub document into array of docs type (es. AA1)
   * itemData: data value of form items
   * action: edito or show doc data
   *
   * @since 1.0.0
   */
   onCancelContractDialogOpen(
    subTopic: string,
    modalTitle: string,
    structureId: string,
    documentKey: string,
    documentId: string,
    subDocumentId: string,
    itemData: any,
    property: any,
    documentArchiveId: string,
  ): void {
    const contract = {
      ...itemData,
      documentArchiveId,
      title: modalTitle,
      companyData: this.loggedUserMaster ? this.companyData : "",
      propertyName: property.ame,
      propertyId: property._id,
    };

    // Open dialog
    const dialogRef = this.cancelContractDialog.open(
      CancelContractDialogComponent,
      {
        minWidth: "60%",
        maxHeight: "98vh",
        data: {
          contract,
          subject: this.translateService.instant(
            "communications.fields.cancelContractSubject"
          ),
          body: this.translateService.instant(
            "communications.fields.cancelContractImmediateBody",
            { title: modalTitle.trim() }
          ),
        },
        disableClose: true,
      }
    );
    
    // On dialog closing, let's update model
    this.subscriptions.push(
      dialogRef.afterClosed().subscribe(
        (res) => {
          if (res) {
            const sendData = {
              msg: res,
            };
            this.subscriptions.push(
              this.documentArchivesService
                .cancelContract(documentArchiveId, sendData)
                .pipe(take(1))
                .subscribe(
                  (res) => {
                    if (!res) {
                      return;
                    } else {
                      // recreate view of all docs to show new inserted doc
                      this.loadPage();
                    }
                  },
                  (err) => {
                    this.helperService.handleError(err);
                  }
                )
            );
          } else {
            // console.warn("TASTO CHIUDI")
          }
        },
        (err) => {
          this.helperService.handleError(err);
        }
      )
    );
  }
  
  /**
   * Handle click on document form to expire contract
   * documentArchiveId: Id of the document archive
   * itemData: data value of the document
   *
   * @since 1.0.0
   */
  onHandleExpiredContract(
    documentArchiveId: string,
    itemData: any,
  ): void {
    const dialogRef = this.dialog.open(
      PropertyExpireContractItemDialogComponent,
      {
        data: {
          documentArchiveId,
          barCode: itemData.barCode ? itemData.barCode : '',
        },
        width: "600px",
      }
    );
    dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(
        (res) => {
          if (!res) {
            return;
          } else {
            // recreate view of all docs to show new inserted doc
           this.loadPage();
          }
        },
        (err) => {
          this.helperService.handleError(err);
        }
      );
  }
}
